<template>
  <div
    v-click-away="closeDropdown"
    :class="large ? 'text-[1.125rem]' : 'text-[1rem]'"
    class="relative border border-[#C3C2C1] bg-[#ffffff] rounded-xl md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] font-inter text-[#191817]"
  >
    <div
      @click="toggleDropdown()"
      :class="large ? 'py-[14px]' : 'py-[12px]'"
      class="bg-caret bg-no-repeat bg-[95%] bg-[length:24px] md:bg-[length:32px] lg:bg-[length:40px] px-[16px] md:px-[20px] lg:px-[24px] md:py-[14px] lg:py-[16px]"
    >
      {{ selected }}
    </div>
    <transition
      enter-active-class="dropdown-enter-active"
      enter-from-class="dropdown-enter-from"
      enter-to-class="dropdown-enter-to"
      leave-active-class="dropdown-leave-active"
      leave-from-class="dropdown-leave-from"
      leave-to-class="dropdown-leave-to"
    >
      <div v-if="showDropdown" class="absolute z-999 w-full">
        <div
          class="w-full flex flex-col text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] text-[#191817] rounded-xl font-inter bg-white overflow-hidden shadow-lg"
        >
          <div
            v-for="(value, key) in options"
            :key="key"
            class="w-full px-[16px] md:px-[20px] lg:px-[24px] py-[12px] md:py-[14px] lg:py-[16px]"
            :class="isCurrentYear(value) ? 'bg-[#FFF6C8]' : 'bg-white'"
            @click="selectYear(value)"
          >
            {{ value }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    selected: {
      type: Number,
      required: true,
    },
    type: {
      //BF or Tithe
      type: String,
      required: true,
    },
    // My BF Fulfilment's 52px field with an 18px year, as its frames draw it.
    large: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {},
  methods: {
    isCurrentYear(year) {
      if (year == this.selected) {
        return true;
      }
      return false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    async selectYear(year) {
      if (this.type === 'tithe') {
        // Use replace instead of push so year changes don't add to history
        this.$router.replace('/my-giving/tithe-history/' + year);
      } else if (this.type === 'bf') {
        // Use replace instead of push so year changes don't add to history
        this.$router.replace('/my-giving/building-fund/' + year);
      } else if (this.type === 'localTransfer') {
        this.$emit('changeSelect', year);
        this.showDropdown = false;
      }
    },
  },
};
</script>
